import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  BokkzAlgDataService,
  BokkzDivDataService, BokkzDivLogic,
  Dividendbelasting,
  DividendTaxEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {Subject, Subscription, takeUntil} from "rxjs";
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-algemeen',
  standalone: true,
    imports: [CommonModule, SharedUiDetailsModule, SharedUiFormControlsModule, SharedUiAlertModule],
  templateUrl: './algemeen.component.html',
  styleUrl: './algemeen.component.scss',
})
export class AlgemeenComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  @Input() public id!: string;
  private intermediairyEntitySubscription: Subscription | undefined;
  private divTaxEntitySubscription: Subscription | undefined;
  public divTaxEntity = {} as DividendTaxEntity;
  public aangifte = {} as Dividendbelasting;
  public dividendFg = {} as FormGroup;
  public algemeenFg = {} as FormGroup;
  public beconNummer: string | undefined;
  public focusedElementId: string | null = null;
  public year: number | undefined;
  public jaartalNietAkkoord = false;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public optionsJaNeeBuitenland: SelectFormControlItem<boolean>[] = [
    {value: false, label: "Nee"},
    {value: true, label: "Ja (nog niet beschikbaar)", disabled:true},

  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzDivDataService,
    public divService: BokkzDivLogic,
    private fb: FormBuilder) {
    this.dividendFg = this.fb.group({
      datumBeschikbaarstelling: null as unknown as Date,
    })
    this.algemeenFg = this.fb.group({
      hasForeignShareholders: false,
      hasAfdrachtvermindering: false,
      volgnummer: 1,
    })
  }

  ngOnInit(): void {
    this.intermediairyEntitySubscription = this.algDataService.intermediary.subscribe((value) => {
      this.beconNummer = value.beconId || undefined;
    })
    this.divTaxEntitySubscription = this.dataService.dividendTaxEntity.subscribe((value) => {
      this.divTaxEntity = value;
      this.aangifte = value.aangifte!;
      this.dividendFg.patchValue(value.aangifte!, {emitEvent: false})
      if (this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)?.afdrachtsVermindering!) {
        this.algemeenFg.patchValue({hasAfdrachtvermindering: true}, {emitEvent: false})
      }
      if (this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)?.belastVerdragsTarief! || this.aangifte.opgaafDb) {
        this.algemeenFg.patchValue({hasForeignShareholders: true}, {emitEvent: false})
      }
      if (this.aangifte.aangifteDb) {
        this.algemeenFg.patchValue({volgnummer: value.aangifte!.aangifteDb?.volgNummer}, {emitEvent: false})
      }
      if (this.divTaxEntity.year !== null) {
        this.year = this.divTaxEntity.year
      }
      this.dividendFg.get('datumBeschikbaarstelling')?.valueChanges
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => {
            this.saveForm();
          });
    })
  }

  ngOnDestroy(): void {
    if (this.intermediairyEntitySubscription) {
      this.intermediairyEntitySubscription.unsubscribe()
    }
    if (this.divTaxEntitySubscription) {
      this.divTaxEntitySubscription.unsubscribe()
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  saveForm(): void {
    this.dividendFg.updateValueAndValidity();
    this.algemeenFg.updateValueAndValidity();
    this.dataService.hasForeignShareholders.next(this.algemeenFg.value.hasForeignShareholders)
    this.dataService.hasAfdrachtvermindering.next(this.algemeenFg.value.hasAfdrachtvermindering)
    setTimeout(()=> {
      this.divTaxEntity.aangifte = {
        ...this.aangifte,
        datumBeschikbaarstelling: this.dividendFg.value.datumBeschikbaarstelling,
        aangifteDb: {
          ...this.aangifte.aangifteDb,
          volgNummer: this.algemeenFg.value.volgnummer,
        }
      } as Dividendbelasting;
      this.dataService.updateDividendTaxEntity(this.divTaxEntity);
      // this.divService.getCalculation(this.divTaxEntity);
    },0)
  }
}
